/**
 * The Network in the console (24/10/2026). Twin of `it.ts`. Only the phone numbers for now: the rest of the Network
 * still has its texts in the code, and moves here when it is touched.
 */
export default {
  telefoni: {
    titolo: 'Phone numbers',
    numero: 'Number',
    etichetta: 'Which number',
    etichetta_esempio: 'mobile, landline, office…',
    principale: 'Main number: the buttons at the top of the card use it',
    rendi_principale: 'Make it the main number',
    chiama: 'Call',
    whatsapp: 'WhatsApp',
    togli: 'Remove this number',
    aggiungi: 'Add a number',
    nessuno: 'No numbers.',
  },
} as const;
